import _toConsumableArray from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import "../has.js";
import { equals as t } from "../lang.js";
import e from "../Logger.js";
import s from "../ObjectPool.js";
import { Property as i } from "./Property.js";
import { idToName as r, nameToId as o } from "./PropertyOrigin.js";
import { Store as n } from "./Store.js";
import { trackAccess as a, runTracked as c, initializeDependencyTracking as l } from "./tracking.js";
import { getProperties as h } from "./utils.js";

function p(t, e, s) {
  return void 0 !== t;
}

function f(t, e, s, i) {
  return void 0 !== t && (!(null == s && 8 & t.flags) || (i.lifecycle, !1));
}

function u(t) {
  return t && "function" == typeof t.destroy;
}

e.getLogger("esri.core.accessorSupport.Properties");

var g = /*#__PURE__*/function () {
  function g(t) {
    _classCallCheck(this, g);

    this.host = t, this.properties = new Map(), this.ctorArgs = null, this.destroyed = !1, this.lifecycle = 0, this.store = new n(), this._origin = 6;
    var e = this.host.constructor.__accessorMetadata__,
        s = e.properties;

    for (var _r in s) {
      var _t = new i(this, _r, s[_r]);

      this.properties.set(_r, _t);
    }

    this.metadatas = s, this._autoDestroy = e.autoDestroy;
  }

  _createClass(g, [{
    key: "initialize",
    value: function initialize() {
      this.lifecycle = 1;
    }
  }, {
    key: "constructed",
    value: function constructed() {
      this.lifecycle = 2;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (this.destroyed = !0, this._autoDestroy) {
        var _iterator = _createForOfIteratorHelper(this.properties),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _step$value = _slicedToArray(_step.value, 2),
                _t2 = _step$value[0],
                _e = _step$value[1];

            var _s = this.internalGet(_t2);

            _s && u(_s) && (_s.destroy(), 8 & ~_e.flags && this._internalSet(_e, null)), _e.destroy();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } else {
        var _iterator2 = _createForOfIteratorHelper(this.properties),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _step2$value = _slicedToArray(_step2.value, 2),
                _t3 = _step2$value[0],
                _e2 = _step2$value[1];

            _e2.destroy();
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    }
  }, {
    key: "initialized",
    get: function get() {
      return 0 !== this.lifecycle;
    }
  }, {
    key: "get",
    value: function get(t) {
      var e = this.properties.get(t);
      if (e.metadata.get) return e.getComputed();
      a(e);
      var s = this.store;
      return s.has(t) ? s.get(t) : e.metadata.value;
    }
  }, {
    key: "originOf",
    value: function originOf(t) {
      var e = this.store.originOf(t);

      if (void 0 === e) {
        var _e3 = this.properties.get(t);

        if (void 0 !== _e3 && 16 & _e3.flags) return "defaults";
      }

      return r(e);
    }
  }, {
    key: "has",
    value: function has(t) {
      return !!this.properties.has(t) && this.store.has(t);
    }
  }, {
    key: "keys",
    value: function keys() {
      return _toConsumableArray(this.properties.keys());
    }
  }, {
    key: "internalGet",
    value: function internalGet(t) {
      var e = this.properties.get(t);
      if (p(e)) return this.store.has(t) ? this.store.get(t) : e.metadata.value;
    }
  }, {
    key: "internalSet",
    value: function internalSet(t, e) {
      var s = this.properties.get(t);
      p(s) && this._internalSet(s, e);
    }
  }, {
    key: "getDependsInfo",
    value: function getDependsInfo(t, e, s) {
      var r = this.properties.get(e);
      if (!p(r)) return "";
      var o = new Set(),
          n = c({
        onObservableAccessed: function onObservableAccessed(t) {
          return o.add(t);
        },
        onTrackingEnd: function onTrackingEnd() {}
      }, function () {
        var e;
        return null == (e = r.metadata.get) ? void 0 : e.call(t);
      });
      var a = "".concat(s).concat(t.declaredClass.split(".").pop(), ".").concat(e, ": ").concat(n, "\n");
      if (0 === o.size) return a;
      s += "  ";

      var _iterator3 = _createForOfIteratorHelper(o),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _c = _step3.value;
          if (!(_c instanceof i)) continue;

          var _t4 = _c.properties.host,
              _e4 = _c.propertyName,
              _r2 = h(_t4);

          a += _r2 ? _r2.getDependsInfo(_t4, _e4, s) : "".concat(s).concat(_e4, ": undefined\n");
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      return a;
    }
  }, {
    key: "setAtOrigin",
    value: function setAtOrigin(t, e, s) {
      var i = this.properties.get(t);
      if (p(i)) return this._setAtOrigin(i, e, s);
    }
  }, {
    key: "isOverridden",
    value: function isOverridden(t) {
      var e = this.properties.get(t);
      return void 0 !== e && !!(2 & e.flags);
    }
  }, {
    key: "clearOverride",
    value: function clearOverride(t) {
      var e = this.properties.get(t);
      void 0 !== e && 2 & e.flags && (e.flags &= -3, e.notifyChange());
    }
  }, {
    key: "override",
    value: function override(t, e) {
      var s = this.properties.get(t);
      if (!f(s, t, e, this)) return;
      var i = s.metadata.cast;

      if (i) {
        var _t5 = this._cast(i, e),
            _s2 = _t5.valid,
            _r3 = _t5.value;

        if (m.release(_t5), !_s2) return;
        e = _r3;
      }

      s.flags |= 2, this._internalSet(s, e);
    }
  }, {
    key: "set",
    value: function set(t, e) {
      var s = this.properties.get(t);
      if (!f(s, t, e, this)) return;
      var i = s.metadata.cast;

      if (i) {
        var _t6 = this._cast(i, e),
            _s3 = _t6.valid,
            _r4 = _t6.value;

        if (m.release(_t6), !_s3) return;
        e = _r4;
      }

      var r = s.metadata.set;
      r ? r.call(this.host, e) : this._internalSet(s, e);
    }
  }, {
    key: "setDefaultOrigin",
    value: function setDefaultOrigin(t) {
      this._origin = o(t);
    }
  }, {
    key: "getDefaultOrigin",
    value: function getDefaultOrigin() {
      return r(this._origin);
    }
  }, {
    key: "notifyChange",
    value: function notifyChange(t) {
      var e = this.properties.get(t);
      void 0 !== e && e.notifyChange();
    }
  }, {
    key: "invalidate",
    value: function invalidate(t) {
      var e = this.properties.get(t);
      void 0 !== e && e.invalidate();
    }
  }, {
    key: "commit",
    value: function commit(t) {
      var e = this.properties.get(t);
      void 0 !== e && e.commit();
    }
  }, {
    key: "_internalSet",
    value: function _internalSet(t, e) {
      var s = 0 !== this.lifecycle ? this._origin : 0;

      this._setAtOrigin(t, e, s);
    }
  }, {
    key: "_setAtOrigin",
    value: function _setAtOrigin(e, s, i) {
      var r = this.store,
          o = e.propertyName;
      r.has(o, i) && t(s, r.get(o)) && 2 & ~e.flags && i === r.originOf(o) || (e.invalidate(), r.set(o, s, i), e.commit(), l(this.host, e));
    }
  }, {
    key: "_cast",
    value: function _cast(t, e) {
      var s = m.acquire();
      return s.valid = !0, s.value = e, t && (s.value = t.call(this.host, e, s)), s;
    }
  }]);

  return g;
}();

var d = /*#__PURE__*/function () {
  function d() {
    _classCallCheck(this, d);

    this.value = null, this.valid = !0;
  }

  _createClass(d, [{
    key: "acquire",
    value: function acquire() {
      this.valid = !0;
    }
  }, {
    key: "release",
    value: function release() {
      this.value = null;
    }
  }]);

  return d;
}();

var m = new s(d);
export { g as default };